import {
  all, put, takeLatest, select,
} from 'redux-saga/effects';

import * as ActionTypes from '../actions/userStatistic/UserStatisticActionsTypes';
import {
  getUserStatisticSuccess,
  getUserStatisticsError
} from '../actions/userStatistic/UserStatisticActions';
import {
  IGetUserStatistic, IPremiumBonusGuestInfo,
} from '../actions/userStatistic/IUserStatisticActions';
import {
  getAllBookingsByRestaurantIdAndPhoneWithPageable, getGuestStatistic, getUserPremiumBonusInfo, getUserVisitInfo,
} from '../api';
import { TReserve } from '../types/IBookingStore';

/** @description Сага для получения статистики по выбранному юзеру */
export function* getUserStatisticSaga(action: IGetUserStatistic) {
  const { userPhoneNumber } = action.payload;

  try {
    const restaurantId = yield select(state => state.cabinet.currentRestaurant.id);
    const userVisits = yield getUserVisitInfo(userPhoneNumber, restaurantId);
    let userPremiumBonus: IPremiumBonusGuestInfo | undefined;

    try {
      userPremiumBonus = yield getUserPremiumBonusInfo(Number(userPhoneNumber), restaurantId);
    } catch (e) {
      console.log("User without premiumBonus");
    }

    if (userVisits.firstVisit === null) {
      const allReserves: Array<TReserve> = yield select(state => state.statistic.reserves);
      const userReserves = allReserves.filter(r => r.phone === userPhoneNumber);

      const mockUser = {
        firstVisit: null,
        lastVisit: null,
        isActive: false,
        name: userVisits.name,
        phone: userVisits.phone,
        groupName: userPremiumBonus?.groupName,
        balance: userPremiumBonus?.balance,
      };

      const mockStat = {
        averageReceiptAmount: 0,
        total: 0,
        totalCancelledByGuest: 0,
        totalCancelledByRestaurant: 0,
        totalClosed: 0,
        totalDeclined: 0,
        totalReceiptAmount: 0,
      };

      yield put(getUserStatisticSuccess(mockUser, mockStat, userReserves, userReserves.length, 0));
    } else {
      const statistics = yield getGuestStatistic(
        restaurantId,
        parseInt(userVisits.phone),
      );

      const bookingList = yield getAllBookingsByRestaurantIdAndPhoneWithPageable(
        restaurantId,
        Number(userVisits.phone),
        userVisits.firstVisit,
        { orderBy: 'date', order: 'desc' },
        action.payload.page,
        action.payload.pageSize,
      );

      yield put(getUserStatisticSuccess({
        ...userVisits,
        groupName: userPremiumBonus?.groupName,
        balance: userPremiumBonus?.balance,
      }, statistics, bookingList.content, bookingList.totalElements, bookingList.totalPages));
    }
  } catch (e) {
    yield put(getUserStatisticsError());
  }
}

export default function* saga() {
  yield all([
    takeLatest(ActionTypes.GET_USER_STATISTIC_REQUEST, getUserStatisticSaga),
  ]);
}
